import { useTurnstile } from "../TurnstileContext";
import { Appearance } from "../types";
import { Anchor, Button, Input, Label, Message } from "./../base-ui/index";
import {
  VIEWS,
  I18nVariables,
  OtpType,
  ViewType,
} from "@supabase/auth-ui-shared";
import {
  EmailOtpType,
  MobileOtpType,
  SupabaseClient,
  VerifyOtpParams,
} from "@supabase/supabase-js";
import React, { useState } from "react";

function VerifyOtp({
  setAuthView = () => {},
  supabaseClient,
  otpType = "email",
  i18n,
  showLinks = false,
}: {
  setAuthView?: (view: ViewType) => void;
  supabaseClient: SupabaseClient;
  otpType: OtpType;
  i18n?: I18nVariables;
  appearance?: Appearance;
  showLinks?: boolean;
}) {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { getToken } = useTurnstile();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    const captchaToken = await getToken();
    let verifyOpts: VerifyOtpParams = {
      email,
      token,
      type: otpType as EmailOtpType,
      options: { captchaToken },
    };
    if (["sms", "phone_change"].includes(otpType)) {
      verifyOpts = {
        phone,
        token,
        type: otpType as MobileOtpType,
        options: { captchaToken },
      };
    }
    const { error } = await supabaseClient.auth.verifyOtp(verifyOpts);
    if (error) {
      setError(error.message);
    }
    setLoading(false);
  };

  const labels = i18n?.verify_otp;

  return (
    <form id="auth-magic-link" onSubmit={(e) => void handleSubmit(e)}>
      <div className="flex flex-col space-y-4 text-left">
        {["sms", "phone_change"].includes(otpType) ? (
          <div>
            <Label htmlFor="phone">{labels?.phone_input_label}</Label>
            <Input
              id="phone"
              name="phone"
              type="text"
              autoFocus
              autoComplete="tel"
              placeholder={labels?.phone_input_placeholder}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setPhone(e.target.value)
              }
            />
          </div>
        ) : (
          <div>
            <Label htmlFor="email">{labels?.email_input_label}</Label>
            <Input
              id="email"
              name="email"
              type="email"
              autoFocus
              autoComplete="email"
              placeholder={labels?.email_input_placeholder}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEmail(e.target.value)
              }
            />
          </div>
        )}
        <div>
          <Label htmlFor="token">{labels?.token_input_label}</Label>
          <Input
            id="token"
            name="token"
            type="text"
            autoComplete="one-time-code"
            placeholder={labels?.token_input_placeholder}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setToken(e.target.value)
            }
          />
        </div>
        <Button color="primary" type="submit" loading={loading}>
          {loading ? labels?.loading_button_label : labels?.button_label}
        </Button>
        {showLinks && (
          <Anchor
            href="#auth-sign-in"
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
              e.preventDefault();
              setAuthView(VIEWS.SIGN_IN);
            }}
          >
            {i18n?.sign_in?.link_text}
          </Anchor>
        )}
        {message && <Message>{message}</Message>}
        {error && <Message color="danger">{error}</Message>}
      </div>
    </form>
  );
}

export { VerifyOtp };
